export default () =>
  import(
    /* webpackChunkName: 'coffee/app/download/community' */ './Community'
  );
